import type { ConversationMode, ModelConfig } from '../types';

export function formatModelLabel(model: ModelConfig) {
  const tags: string[] = [];
  if (model.is_global) {
    tags.push('global');
  }
  if (model.is_default) {
    tags.push('default');
  }
  return `${model.name}${tags.length ? ` (${tags.join(' ')})` : ''}`;
}

export function formatConversationMode(mode?: ConversationMode | null) {
  switch (mode) {
    case 'multi':
      return 'multi';
    case 'none':
      return 'no-app';
    default:
      return 'app';
  }
}
